import styled from "@emotion/styled";
import UserImage from "@components/item/UserImage";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const UserInfoCard = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const { getUserInfo } = useApiRequest();

  const { data: userInfo, isLoading: userLoading } = useQuery({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
  });

  return userLoading ? (
    <></>
  ) : (
    <Container>
      <InfoWrapper>
        <NicknameBox>
          {userInfo?.nickname}

          <EditButton
            onClick={() => {
              navigate("/profile-edit");
            }}>
            <Image
              src={theme.image.edit_icon.default}
              width="2rem"
              height="2rem"
            />
          </EditButton>
        </NicknameBox>

        <Email>{userInfo?.login_id}</Email>
      </InfoWrapper>
      <UserImage src={userInfo?.profile_image} />
    </Container>
  );
};

export default UserInfoCard;

const Container = styled.div<{ button?: boolean }>(({ button, theme }) => ({
  position: "relative",
  display: "flex",
  gap: "1rem",
  alignItems: "flex-start",
  justifyContent: "space-between",
  border: button ? `1px solid ${theme.color.border_gray}` : "none",
  padding: "2rem",
  background: theme.color.white,
}));

const InfoWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const NicknameBox = styled.div<{ button?: boolean }>(({ theme, button }) => ({
  display: "flex",
  alignItems: button ? "flex-end" : "center",
  gap: "1rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2.4rem",

  ".sell_count": {
    color: "#969696",
    fontWeight: theme.fontWeight.regular,
    fontSize: "1.2rem",
    lineHeight: "2rem",
  },
}));

const Email = styled.span(({ theme }) => ({
  color: theme.color.light_gray,
  fontWeight: theme.fontWeight.medium,
}));

const EditButton = styled.button({
  display: "flex",
});
